import * as React from 'react';
import classnames from 'classnames';
import Base, { Props as BaseProps } from '../Base/Base';
import './Hamburger.css';

export interface Props extends BaseProps {
  /** Sets the active state of the icon. */
  active?: boolean;
  /** Sets the size of the icon */
  size?: string;
}

/**
 * An animating Hamburger icon, ideal for those mobile menus.
 */
const Hamburger: React.FunctionComponent<Props> = (props: Props) => {
  const { active, size, ...rest } = props;
  const classes = classnames('Hamburger', {
    'Hamburger--active': active,
  });

  return (
    <Base { ...rest }
        className={ classes }
        height={ size }
        width={ size }>
      <div className="Hamburger--bar" />
    </Base>
  );
};

Hamburger.defaultProps = {
  size: '1.5rem',
};

export default Hamburger;
